<template>
  <div :class="['e6-header', { 'is-collapse': collapse }]">
    <div :class="['header__logo']">
      <div
        :class="[
          'header__logo_img',
          $GLOBAL_CONFIG.imageDirName == 'guangdong' ? 'logo_gd' : 'logo_zz',
        ]"
      >
        <span v-if="$GLOBAL_CONFIG.imageDirName == 'guangdong'" class="title">
          广东冷链
        </span>
      </div>
    </div>
    <div :class="['header__collapse', collapse ? 'bgBlue' : '']">
      <i
        @click="handleCollapse()"
        :class="[
          'icon-is-collapse',
          !collapse ? 'e6-icon-menu_open' : 'e6-icon-menu_off',
        ]"
      ></i>
    </div>
    <div v-if="$GLOBAL_CONFIG.imageDirName == 'guangdong'" class="sub_title">
      广东{{ subModuleTitle ? `(${subModuleTitle})` : "" }}冷链公共服务管理平台
    </div>
    <el-dropdown
      class="header__user-setting"
      trigger="click"
      placement="bottom"
      @command="handleUserSetting"
    >
      <span class="el-dropdown-link">
        <span :title="userName" class="user-name">{{ userName }}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="2">修改密码</el-dropdown-item>
        <el-dropdown-item command="1">{{
          $t("_private.logout")
        }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      custom-class="e6-column-dialog"
      title="修改密码"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="490px"
    >
      <div class="column-wrapper">
        <el-form
          status-icon
          :model="ruleForm"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item
            label="原始密码"
            prop="oldPassword"
            :rules="[
              { required: true, message: '请输入原始密码', trigger: 'blur' },
            ]"
          >
            <el-input type="password" v-model="ruleForm.oldPassword"></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            prop="newPassword"
            :rules="[
              { required: true, message: '请输入密码', trigger: 'blur' },
            ]"
          >
            <el-input
              type="password"
              v-model="ruleForm.newPassword"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="确认密码"
            prop="confirmPassword"
            :rules="[
              { required: true, message: '请确认密码', trigger: 'blur' },
            ]"
          >
            <el-input
              type="password"
              v-model="ruleForm.confirmPassword"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmitForm">{{
          $t("_private.button.confirm")
        }}</el-button>
        <el-button @click="handleCancelForm">{{
          $t("_private.button.cancel")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { FetchModifyPassword } from "_private/api/public";
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["collapse"],
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  computed: {
    ...mapGetters(["userName", "subModuleTitle"]),
  },
  methods: {
    ...mapActions(["logoutAct"]),
    // 修改密码
    FetchModifyPassword(data) {
      FetchModifyPassword(data)
        .then((response) => {
          this.submitCallback(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleCollapse() {
      this.$emit("update:collapse", this.collapse ? false : true);
    },
    handleUserSetting(e) {
      switch (e) {
        case "1":
          this.logout();
          break;
        case "2":
          this.dialogVisible = true;
          break;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitCallback(data) {
      let type = data.code === 1 ? "success" : "error";
      let message = data.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.dialogVisible = false;
            this.logout();
          }
        },
      });
    },
    handleSubmitForm() {
      this.FetchModifyPassword(this.ruleForm);
    },
    handleCancelForm() {
      this.dialogVisible = false;
      this.resetForm("ruleForm");
    },
    async logout() {
      await this.logoutAct();
      this.$router.push("/login");
      // 退出登录后，页面要重新刷新一下，为了解决动态路由重复添加
      location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "_private/assets/styles/common/var.scss";
@import "_private/assets/styles/mixins/utils.scss";

$--header-height: 50px !default;
.e6-header {
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;
  color: $--header-left-color;
  background: $--header-left-background-color;
  &.is-collapse {
    .header__logo {
      width: 0;
      overflow: hidden;
    }
    .header__collapse {
      margin-left: 0;
      .icon-is-collapse {
        margin: 0 23px;
      }
    }
  }
  .header__logo {
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -($--header-height/2);
    height: $--header-height;
    width: ($--menu-width);
    // width: 120px;
    background-image: linear-gradient(to right, #3840f4, #076aed);
    font-size: 16px;
    text-align: center;
    transition: width 0.5s ease;
    .header__logo_img {
      display: flex;
      align-items: center;
      height: $--header-height;
      background-position: 20px center;
      background-repeat: no-repeat;
      .title {
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        position: relative;
        left: 70px;
      }
    }
  }
  .logo_gd {
    background: url("~@/assets/images/guangdong/header-logo.png") no-repeat;
  }
  .logo_zz {
    background: url("~@/assets/images/zhengzhou/header-logo.png") no-repeat;
  }
  .header__user-setting {
    position: absolute;
    top: 50%;
    right: 15px;
    margin-top: -9px;
    color: $--menu-header-color;
    cursor: pointer;
    .user-name {
      display: inline-block;
      width: 80px;
      vertical-align: bottom;
      text-align: center;
      @include utils-ellipsis;
    }
  }
  .header__collapse {
    margin-left: ($--menu-width);
    height: $--header-height;
    line-height: $--header-height;
    transition: margin-left 0.5s ease;
    .icon-is-collapse {
      font-size: 18px;
      margin-left: 15px;
      cursor: pointer;
    }
    &.bgBlue {
      background: #3a45f4;
    }
  }
  .sub_title {
    margin-left: 30px;
    font-size: 22px;
  }
  /deep/ .e6-column-dialog {
    .column-wrapper {
      padding: 40px 0 20px;
    }
    .el-form {
      margin-left: 20px;
      width: 400px;
    }
  }
}
.e6-menu-section {
  color: $--menu-color;
  background-color: transparent !important;
}
</style>
